<div class="d-flex flex-row flex-wrap">
  <div class="d-flex flex-column flex-wrap" style="flex: 1; width: 100%">
    <lib-prod-header [title]="siteSetting" [icon]="'info_outline'" [class]="'company-upper'" style="width: 100%">
      <app-company-detail [isSite]="true"></app-company-detail>
    </lib-prod-header>
    <lib-prod-grid style="flex: 1; width: 100%"
      [title]="prodGridTitle"
      [icon]="'dataset'"
      [class]="'company-lower p-0'"
      [columns]="prodGridColumns"
      [isAddButtonShown]="true"
      [isAddButtonDisabled]="isAddButtonDisabled"
      [isEditButtonShown]="true"
      [isRemoveButtonShown]="true"
      [isRemoveButtonDisabled]="isRemoveButtonDisabled"
      [headerButtons]="prodGridHeaderButtons"
      [matTableDataSource]="matTableDataSource"
      [inputAction$]="inputAction$"
      (outputAction$)="outputActionEvents($event)"></lib-prod-grid>
  </div>

  <lib-prod-header [title]="siteSettingMap" [icon]="'hub'" [class]="'site-tab'" style="flex: 1">
    <lib-prod-map
      [markers$]="gridMapService.markers$"
      [markerSelected$]="gridMapService.markerSelected$"
      [mapName]="'hubMap'"
      [isMarkersHasCircles]="true"
      [mapFilter$]="gridMapService.mapFilter$"
      [mapBounds$]="gridMapService.mapBounds$"
      [isCirclesPulse]="true"
      (prodMapEvents$)="prodMapEvents($event)"></lib-prod-map>
  </lib-prod-header>
</div>
